import { render, staticRenderFns } from "./AdminUserMenu.vue?vue&type=template&id=7639785e"
import script from "./AdminUserMenu.vue?vue&type=script&lang=ts"
export * from "./AdminUserMenu.vue?vue&type=script&lang=ts"
import style0 from "./AdminUserMenu.vue?vue&type=style&index=0&id=7639785e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports